/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1Feedback200,
  GetApiV1Feedback401,
  GetApiV1Feedback500,
  GetApiV1FeedbackQueryParams,
  GetApiV1FeedbackQueryResponse,
} from "../../types/feedbackRegistroController/GetApiV1Feedback.ts";
import { feedbackGridItemViewModelPaginatedResponseSchema } from "../feedbackGridItemViewModelPaginatedResponseSchema.ts";

export const getApiV1FeedbackQueryParamsSchema = z.object({
  companyId: z.optional(z.coerce.number().int()),
  filter: z.optional(z.string()),
  active: z.optional(z.boolean()),
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1FeedbackQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1Feedback200Schema = z.lazy(
  () => feedbackGridItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1Feedback200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1Feedback401Schema =
  z.any() as unknown as ToZod<GetApiV1Feedback401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1Feedback500Schema =
  z.any() as unknown as ToZod<GetApiV1Feedback500>;

export const getApiV1FeedbackQueryResponseSchema = z.lazy(
  () => getApiV1Feedback200Schema,
) as unknown as ToZod<GetApiV1FeedbackQueryResponse>;
